import { inject, Pipe, PipeTransform } from '@angular/core';
import { campsenum } from '../../models/enums.generated';
import { CampsEnumTranslationService } from '../../services/camps-enum-translation.service';

@Pipe({ name: 'translatePurchaseStatus' })
export class TranslatePurchaseStatusPipe implements PipeTransform {
  private enumTranslationService = inject(CampsEnumTranslationService);

  transform(status: campsenum.CampPurchaseStatus): string {
    return this.enumTranslationService.purchaseStatus(status);
  }
}
